import React, {useEffect} from 'react'
import BookCabMain from './BookCabMain'

const BookCab = () => {
  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
        <BookCabMain></BookCabMain>
    </div>
  )
}

export default BookCab